import { useFormatNumber } from '@dreamstack/i18n'
import { irr } from 'node-irr'
import type { FunctionComponent } from 'react'
import type { BTLCalcTableEntry } from './BTLCalcUtil'
import { formatOptionsDecimal0, formatOptionsDecimal1 } from './BTLCalcUtil'

const getNetFinancialGain = (
  tableData: BTLCalcTableEntry[],
  years: number,
  putDownValue: number
): number => {
  return (tableData[years]?.netGain || 0) + putDownValue
}

const getReturnOnInvestedCapital = (
  tableData: BTLCalcTableEntry[],
  years: number,
  putDownValue: number
): any => {
  const arr = [-putDownValue]
  for (let i = 0; i < years - 1; i++) {
    arr.push(0)
  }
  arr.push(getNetFinancialGain(tableData, years, putDownValue))
  return irr(arr, { estimate: 0.2 })
}

const getFormattedIRR = (
  tableData: any,
  years: any,
  putDownValue: any,
  format: any
) => {
  return (
    format(100 * getReturnOnInvestedCapital(tableData, years, putDownValue)) +
    '%'
  )
}

export const BTLCalcBlock4: FunctionComponent<
  React.PropsWithChildren<{
    tableData: BTLCalcTableEntry[]
    putDownValue: number
  }>
> = (props) => {
  const { tableData, putDownValue } = props

  const formatAbsolute = useFormatNumber(formatOptionsDecimal0)
  const formatPercentage = useFormatNumber(formatOptionsDecimal1)

  return (
    <div className="p-px-24">
      <div className="flex-1 text-[20px] font-semibold pt-px-12 pb-px-20">
        Net Financial Gain
      </div>

      <div className="flex flex-row flex-1">
        <div className="flex-1 text-[16px]">
          10 years
          <br />
          <span className="font-semibold">
            {formatAbsolute(tableData[10]?.netGain || 0) + ' EUR'}
          </span>
        </div>
        <div className="flex-1 text-[16px]">
          15 years
          <br />
          <span className="font-semibold">
            {formatAbsolute(tableData[15]?.netGain || 0) + ' EUR'}
          </span>
        </div>
        <div className="flex-1 text-[16px]">
          20 years
          <br />
          <span className="font-semibold">
            {formatAbsolute(tableData[20]?.netGain || 0) + ' EUR'}
          </span>
        </div>
      </div>

      <div className="flex-1 text-[20px] font-semibold pt-px-48 pb-px-20">
        Return on Invested Capital
      </div>

      <div className="flex flex-row flex-1">
        <div className="flex-1 text-[16px]">
          10 years
          <br />
          <span className="font-semibold">
            {getFormattedIRR(tableData, 10, putDownValue, formatPercentage)}
          </span>
        </div>
        <div className="flex-1 text-[16px]">
          15 years
          <br />
          <span className="font-semibold">
            {getFormattedIRR(tableData, 15, putDownValue, formatPercentage)}
          </span>
        </div>
        <div className="flex-1 text-[16px]">
          20 years
          <br />
          <span className="font-semibold">
            {getFormattedIRR(tableData, 20, putDownValue, formatPercentage)}
          </span>
        </div>
      </div>
    </div>
  )
}
